import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: colors.space15,
    borderRadius: '4px',
    overflow: 'hidden',
  },
});

export default styles;
